import { tableController, translate } from 'magner';
import { TableColumn } from 'magner/lib/types/components/table';
import { ModerationList } from 'features/moderation/types/gaz';
import { formatDate, formatPhone } from '~/utils/format-date';

export const fioColumn: TableColumn<ModerationList> = {
  prop: 'fio',
  label: translate('hubstr.moderation.table.fio'),
  minWidth: 220,
  fixed: 'left',
};

export const phoneColumn: TableColumn<ModerationList> = {
  prop: 'phone',
  label: translate('hubstr.moderation.table.phone'),
  minWidth: 180,
  view: {
    type: 'text',
    formatter: (_, row) => formatPhone(row.phone),
  },
};

export const emailColumn: TableColumn<ModerationList> = {
  prop: 'email',
  label: translate('hubstr.moderation.table.email'),
  minWidth: 250,
};

export const departmentColumn: TableColumn<ModerationList> = {
  prop: 'departmentName',
  label: translate('hubstr.moderation.table.department'),
  minWidth: 200,
};

export const createdAtColumn: TableColumn<ModerationList> = {
  prop: 'createdAt',
  label: translate('hubstr.moderation.table.created'),
  minWidth: 180,
  view: {
    type: 'text',
    formatter: (_, row) => formatDate(row.createdAt as unknown as Date),
  },
};

const moderationTable = tableController<ModerationList>({
  tableLayout: 'auto',
  scrollbarAlwaysOn: true,
  emptyText: translate('hubstr.moderation.table.not_found'),
  rowLink: (row) => ({ name: 'moderation-card', params: { id: row.id } }),
  columns: [
    fioColumn,
    phoneColumn,
    emailColumn,
    departmentColumn,
    createdAtColumn,
  ],
});

export default moderationTable;